<template>
  <div class="companyLogo">
    <!-- Trusted Section start -->
    <section class="row_am trusted_section">
      <!-- container start -->
      <div class="container">
        <div
          class="section_title"
          data-aos="fade-up"
          data-aos-duration="1500"
          data-aos-delay="100"
        >
          <h2>Trusted by <span>150+</span> Beauty Pros & Clients</h2>
          <p>
            From top stylists to loyal clients, SALT is the go-to platform for seamless braid bookings, style inspiration, and hair care confidence.<br />
            Join the community that’s redefining protective styling.
          </p>
        </div>

        <!-- logos slider start -->
        <div class="company_logos">
          <swiper
            :modules="modules"
            :slides-per-view="5"
            :space-between="40"
            :loop="true"
            :autoplay="{
              delay: 2500,
              disableOnInteraction: false,
              pauseOnMouseEnter: true
            }"
            :pagination="{
              clickable: true,
              dynamicBullets: true
            }"
            :speed="900"
            :breakpoints="{
              320: { slidesPerView: 2, spaceBetween: 20 },
              480: { slidesPerView: 3, spaceBetween: 25 },
              768: { slidesPerView: 4, spaceBetween: 30 },
              1024: { slidesPerView: 5, spaceBetween: 40 }
            }"
            class="mySwiper"
          >
            <swiper-slide v-for="(logo, index) in logos" :key="index">
              <div class="logo">
                <img :src="`images/${logo}`" :alt="`Trusted partner ${index + 1}`" />
              </div>
            </swiper-slide>
          </swiper>
        </div>
        <!-- logos slider end -->
      </div>
      <!-- container end -->
    </section>
    <!-- Trusted Section ends -->
  </div>
</template>

<script setup>
// Import Swiper Vue Components
import { Swiper, SwiperSlide } from 'swiper/vue';

// Import required modules
import { Autoplay, Pagination } from 'swiper/modules';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';

// Logo image list
const logos = [
  'paypal.png',
  'spoty.png',
  'shopboat.png',
  'slack.png',
  'envato.png',
  'paypal.png',
  'spoty.png',
  'shopboat.png'
];

// Modules to use
const modules = [Autoplay, Pagination];
</script>

<style scoped>
.company_logos {
  margin-top: 40px;
  padding: 20px 0;
}

.mySwiper {
  overflow: hidden;
  padding-bottom: 30px;
}

:deep(.swiper-slide) {
  display: flex;
  justify-content: center;
  align-items: center;
  filter: grayscale(100%);
  opacity: 1;
  transition: all 0.3s ease;
}

:deep(.swiper-slide:hover),
:deep(.swiper-slide-active) {
  filter: grayscale(0%);
  opacity: 1;
}

:deep(.swiper-slide img) {
  max-width: 100%;
  max-height: 60px;
  object-fit: contain;
  transition: transform 0.3s ease;
}

:deep(.swiper-pagination) {
  position: relative;
  bottom: 0;
  margin-top: 20px;
}

:deep(.swiper-pagination-bullet) {
  width: 10px;
  height: 10px;
  background-color: #ccc;
  opacity: 1;
  transition: all 0.3s ease;
}

:deep(.swiper-pagination-bullet-active) {
  background-color: #000;
  transform: scale(1.2);
}
</style>